import { useQuery } from "@tanstack/react-query";
import { fetchEffectiveScopes } from "../../api/uct";
import { useAuth } from "./useAuth";
import { useRole } from "./useRole";

/** Le porteur détient-il ce scope dans ses droits effectifs (UCT) ? Une action
 * qui l'exige ne s'affiche pas sans lui : le module la refuserait. Tant que les
 * droits ne sont pas lus, ou s'ils sont illisibles, la réponse est non. */
export function useGrantedScope(scope: string): boolean {
  const { user } = useAuth();
  const sub = user?.profile.sub;
  const { data } = useQuery({
    queryKey: ["uct", "effective-scopes", sub],
    queryFn: fetchEffectiveScopes,
    enabled: Boolean(sub),
    staleTime: 5 * 60_000,
    retry: false,
  });
  return data?.includes(scope) ?? false;
}

/** Action d'administration : rôle admin ET scope effectif du porteur. */
export function useAdminScope(scope: string): boolean {
  const role = useRole();
  const granted = useGrantedScope(scope);
  return role === "admin" && granted;
}
